import { Controller } from "@hotwired/stimulus";
import {
  AdminPreferences,
  AdminPreferencesTracker,
  PreferenceUpdate
} from "controllers/admin/admin_preferences_tracker";

export default class AdminPreferencesController extends Controller {
  updateHook?: PreferenceUpdate;

  connect() {
    this.updateHook ??= this.updateSelectedPreferences.bind(this);
    AdminPreferencesTracker.instance().register(this.updateHook);
  }

  updateSelectedPreferences(prefs: AdminPreferences) {
    const columns = prefs.dashboard.columns;

    this.element.querySelectorAll("#preferences-dashboard-columns option")
      .forEach((el) => {
        const opt = el as HTMLOptionElement;
        opt.selected = opt.value == columns.toString();
      });
  }

  setColumns(e : Event) {
    const element = e.currentTarget as HTMLSelectElement;
    const value = element.selectedOptions[0].value;

    const preferenceData = {
      dashboard: {
        columns: parseInt(value)
      }
    };

    AdminPreferencesTracker.instance().update(preferenceData);
  }
}
